import Vue from 'vue'
import VueRouter from 'vue-router'
import otherApp from './otherApp'

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const files = require.context('./modules', false, /\.js$/);
const modulesRoutes = [];
files.keys().forEach((key) => {
    const router = files(key).default || files(key);
    modulesRoutes.push(...router);
});

const routes = [
    {
        path: '/',
        name: 'Entry',
        component: () => import('../views/Entry.vue'),
    },
    {
        path: '/Home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        children: [
            /**
            *** 首页概览
            **/
            {
                name: "首页概览",
                path: "/HomeOverview",
                // component: () => import('../views/school/homeOverview/index.vue')
                component: () => import('@/views/homePage/index.vue'),
            },
            {
                name: "首页详情",
                path: "/HomeDetail",
                // component: () => import('../views/school/homeOverview/index.vue')
                component: () => import('@/views/homePage/detail.vue'),
            },
            {
                name: "back",
                path: "/back",
                component: () => import('../views/back.vue')
            },
            ...modulesRoutes
        ],
    },
    ...otherApp
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.VUE_APP_API_URL,
    routes
})
router.beforeEach((to, from, next) => {
    //保存当前路由路径
    sessionStorage.routerPath=from.path
    next();
})

export default router